/* NECCST PDP buy box: variant selection by OPTION NAME (not index), live price,
   per-build price labels, native sold-out fallback, finish -> gallery lead image swap.
   Works for a two-axis product (build VERSION + finish BASE PLATE) and a single-variant
   product (no build/finish controls -> the single variant is selected on load).
   Broadcasts the live config on `neccst:variant-change` so the sticky bar can mirror it. */
(function () {
  var box = document.querySelector('[data-neccst-buybox]');
  if (!box) return;

  var dataEl = box.querySelector('[data-neccst-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

  // 1-based option positions recorded server-side; 0 = axis absent.
  var buildPos = parseInt(box.getAttribute('data-build-pos'), 10) || 0;
  var finishPos = parseInt(box.getAttribute('data-finish-pos'), 10) || 0;

  var form = box.querySelector('[data-neccst-form]');
  var idInput = box.querySelector('[data-bb-variant-id]');
  var priceEl = box.querySelector('[data-bb-price]');
  var addBtn = box.querySelector('[data-bb-add]');
  var stockEl = box.querySelector('[data-bb-stock]');
  var titleEl = box.querySelector('[data-bb-title]');
  var subEl = box.querySelector('[data-bb-sub]');
  // Localized button labels come from data attributes on .bb-cta (set from neccst.* locale keys).
  var ctaEl = box.querySelector('.bb-cta');
  var addLabel = (ctaEl && ctaEl.getAttribute('data-i18n-add')) || 'Add to cart';
  var soldOutLabel = (ctaEl && ctaEl.getAttribute('data-i18n-soldout')) || 'Sold out';
  var currentAddLabel = addLabel;
  var buildBtns = [].slice.call(box.querySelectorAll('[data-bb-builds] .build-opt'));
  var finishBtns = [].slice.call(box.querySelectorAll('[data-bb-finishes] .swatch'));

  function selectedValue(btns) {
    var on = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
    return on ? on.getAttribute('data-build') || on.getAttribute('data-finish') : null;
  }

  // Find the variant matching the current build + finish selections (by value at its position).
  function matchVariant() {
    var wantBuild = buildPos ? selectedValue(buildBtns) : null;
    var wantFinish = finishPos ? selectedValue(finishBtns) : null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (buildPos && v.options[buildPos - 1] !== wantBuild) continue;
      if (finishPos && v.options[finishPos - 1] !== wantFinish) continue;
      return v;
    }
    return variants[0] || null;
  }

  function setAvailability(available) {
    if (!addBtn) return;
    if (available) {
      addBtn.disabled = false;
      addBtn.removeAttribute('aria-disabled');
      addBtn.innerHTML = currentAddLabel + ' <span class="arrow" aria-hidden="true">→</span>';
      if (stockEl) stockEl.hidden = false;
    } else {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.textContent = soldOutLabel;
      if (stockEl) stockEl.hidden = true;
    }
  }

  // Dynamic title (NECCST Series 1 -> + GBW), subheadline and CTA label per build.
  function applyBuildMeta() {
    var btn = buildBtns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || buildBtns[0];
    if (!btn) return;
    var t = btn.getAttribute('data-title');
    var s = btn.getAttribute('data-sub');
    var c = btn.getAttribute('data-cta');
    if (t && titleEl) {
      var m = t.match(/^(.*)\sGBW$/);
      if (m) { titleEl.innerHTML = m[1] + ' <span class="bb-gbw">GBW</span>'; }
      else { titleEl.textContent = t; }
    }
    if (s && subEl) { subEl.textContent = s; }
    if (c) { currentAddLabel = c; }
  }

  function update() {
    var v = matchVariant();
    if (!v) return;
    if (buildPos) applyBuildMeta();
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = v.price;
    setAvailability(v.available);

    // Per-build price label: show the price of the matched variant for each build value.
    if (buildPos) {
      buildBtns.forEach(function (b) {
        var bval = b.getAttribute('data-build');
        var pv = priceForBuild(bval);
        var label = b.querySelector('[data-bo-price]');
        if (label && pv) label.textContent = pv.price;
        b.setAttribute('aria-disabled', anyAvailableForBuild(bval) ? 'false' : 'true');
      });
    }

    // Gallery media (incl. finish swap) is driven entirely by neccst-gallery.js, which
    // listens for the neccst:variant-change event below and rebuilds the visible cells from
    // the variant's assigned media. No lead-src patching here anymore (P8).

    box.dispatchEvent(new CustomEvent('neccst:variant-change', {
      bubbles: true,
      detail: {
        id: v.id,
        price: v.price,
        available: v.available,
        title: box.querySelector('[data-bb-title]') ? box.querySelector('[data-bb-title]').textContent : '',
        build: buildPos ? selectedValue(buildBtns) : null,
        finish: finishPos ? finishName() : null,
        finishToken: finishPos ? finishTok() : null
      }
    }));
  }

  function priceForBuild(bval) {
    var wantFinish = finishPos ? selectedValue(finishBtns) : null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[buildPos - 1] !== bval) continue;
      if (finishPos && wantFinish && v.options[finishPos - 1] !== wantFinish) continue;
      return v;
    }
    // fall back to the first variant on this build
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].options[buildPos - 1] === bval) return variants[j];
    }
    return null;
  }

  function anyAvailableForBuild(bval) {
    return variants.some(function (v) { return v.options[buildPos - 1] === bval && v.available; });
  }

  function finishName() {
    var active = finishBtns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || finishBtns[0];
    return active ? active.getAttribute('data-name') : null;
  }
  // Locale-proof finish token (wood|black) for the gallery; display names localize, this doesn't.
  function finishTok() {
    var active = finishBtns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || finishBtns[0];
    return active ? active.getAttribute('data-finish-token') : null;
  }

  function pressGroup(btns, btn) {
    btns.forEach(function (b) {
      var on = (b === btn);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-active', on);
    });
  }

  buildBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      pressGroup(buildBtns, btn);
      update();
    });
  });
  finishBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      pressGroup(finishBtns, btn);
      update();
    });
  });

  // Honor a ?variant= deep link (and the homepage's ?build= shortcut) on load.
  var params = new URLSearchParams(location.search);
  var wantVariant = params.get('variant');
  var wantBuild = params.get('build');
  if (wantVariant && buildPos) {
    var dv = variants.filter(function (v) { return String(v.id) === wantVariant; })[0];
    if (dv) {
      buildBtns.forEach(function (b) { if (b.getAttribute('data-build') === dv.options[buildPos - 1]) pressGroup(buildBtns, b); });
      if (finishPos) finishBtns.forEach(function (b) { if (b.getAttribute('data-finish') === dv.options[finishPos - 1]) pressGroup(finishBtns, b); });
    }
  } else if (wantBuild && buildPos) {
    // map a loose shortcut (e.g. "gbw") to a build value containing it
    buildBtns.forEach(function (b) {
      if (b.getAttribute('data-build').toLowerCase().indexOf(wantBuild.toLowerCase()) !== -1) pressGroup(buildBtns, b);
    });
  }

  // AJAX add to cart -> open the overlay drawer. Falls back to a normal form POST
  // (full page -> /cart) when the drawer isn't present (e.g. cart_type = page).
  var cartDrawer = document.querySelector('cart-drawer');

  function refreshDrawer() {
    return fetch(location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var cur = cartDrawer.querySelector('.drawer__inner');
        if (fresh && cur) cur.replaceWith(fresh); // keep the overlay (and its close listener) intact
        cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.open === 'function') cartDrawer.open();
        else cartDrawer.classList.add('animate', 'active');
        // mirror the new count in the header cart link
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var link = document.querySelector('#cart-icon-bubble');
            if (link && typeof c.item_count === 'number') {
              link.textContent = link.textContent.replace(/\(\d+\)/, '(' + c.item_count + ')');
            }
          })
          .catch(function () {});
      });
  }

  if (form && cartDrawer) {
    form.addEventListener('submit', function (e) {
      if (addBtn && (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true')) return;
      e.preventDefault();
      var orig = addBtn ? addBtn.innerHTML : '';
      if (addBtn) { addBtn.setAttribute('aria-busy', 'true'); addBtn.innerHTML = 'Adding…'; }
      fetch(form.getAttribute('action') || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) { return; } // add error (e.g. sold out): leave the page as-is
          return refreshDrawer();
        })
        .catch(function () { form.submit(); })
        .then(function () { if (addBtn) { addBtn.removeAttribute('aria-busy'); addBtn.innerHTML = orig; } });
    });
  }

  update();
})();
